import { render, staticRenderFns } from "./JobPreviewDescriptionSp.vue?vue&type=template&id=0a0ed0c5&scoped=true"
import script from "./JobPreviewDescriptionSp.vue?vue&type=script&lang=js"
export * from "./JobPreviewDescriptionSp.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewDescriptionSp.vue?vue&type=style&index=0&id=0a0ed0c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0ed0c5",
  null
  
)

export default component.exports